import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {RetroalimentacionService} from '../_services/retroalimentacion.service';
import {EstudioService} from '../../estudio.service';
import {DomSanitizer} from '@angular/platform-browser';
import {AccountService} from '../../../../_services/account.service';
import {ActivatedRoute} from '@angular/router';
import {AsistenciaService} from '../../../asistencia/_services/asistencia.service';
import {DynamicBarService} from '../../../../_components/dynamic-bar/dynamic-bar.service';

@Component({
  selector: 'retroalimentacion-mis-materias',
  standalone: false,
  templateUrl: 'retroalimentacion-mis-materias.component.html',
  styleUrls: ['./retroalimentacion-mis-materias.component.scss'],
  host: {
    '(document:click)': 'offClick($event)',
  }
})

export class RetroalimentacionMisMateriasComponent implements OnInit, AfterViewInit {
  materias: any[];
  me: any;

  columnas: any[] = [];

  numColumnas = 1;
  anchoColumnas: any;
  anchoFicha: number;

  overlay = false;
  overlayHeight = '';
  @ViewChild('contenedorMaterias', { static: false }) contenedorMaterias: ElementRef;

  constructor(private san: DomSanitizer,
              private route: ActivatedRoute,
              private retroalimentacionService: RetroalimentacionService,
              private estudioService: EstudioService,
              private accountService: AccountService,
              private asistenciaService: AsistenciaService,
              private dynamicBarService: DynamicBarService) {
  }

  ngOnInit() {
    const alumnoID = this.route.snapshot.paramMap.get('alumnoID') || 'me';

    this.accountService.getPersona(alumnoID).subscribe(res => {
      this.me = this.estudioService.extractData(res);

      this.dynamicBarService.setBarra('dashboard-retroalimentacion-materias-barra', {alumno: this.me});
      this.loadData();
    });

  }

  loadData() {
    const alumnoID = this.me && this.me.id > 0 ? this.me.id : 0;
    this.retroalimentacionService.getMisMaterias(alumnoID).subscribe(res => {
      this.materias = this.estudioService.extractData(res);
      this.sortColumnas();
    });
  }

  ngAfterViewInit() {
    const ancho = 260;
    this.numColumnas = Math.floor(window.innerWidth / ancho) === 0 ? 1 :
      Math.floor(window.innerWidth / ancho); // TODO: El ancho de la ficha debe ser asignable
    this.anchoFicha = (window.innerWidth - 64) / this.numColumnas;
    this.anchoColumnas = this.san.bypassSecurityTrustStyle(`calc(100% / ${this.numColumnas})`);

    for (let i = 0; i < this.numColumnas; i++) {
      this.columnas[i] = {els: []};
    }
  }

  detallesAsistencia(materia, property) {
    if (materia.hasOwnProperty(property) && materia[property].show) {
      materia[property] = {show: false};
    } else {
      materia[property] = {show: false};
      if (property === 'detalleAus') {
        this.asistenciaService.getDetailAcumulada(this.me.id, materia.id).subscribe(res => {
          materia[property]['listaDetalles'] = this.asistenciaService.extractData(res);
          materia[property].show = true;
          this.overlay = true;
        });
      } else {
        materia[property].show = true;
        this.overlay = true;
      }
    }
  }

  offClick(event) {
    this.overlayHeight = `${this.contenedorMaterias.nativeElement.offsetHeight + 128}px`;
    if (event.target.classList.contains('custom-overlay')) {
      this.overlay = false;
      this.materias.map(materia => {
        if (materia.hasOwnProperty('detalleAus') && materia.detalleAus.show) {
          materia.detalleAus.show = false;
        }
        if (materia.hasOwnProperty('detalleNiv') && materia.detalleNiv.show) {
          materia.detalleNiv.show = false;
        }
      });
    }
  }

  // Métodos privados
  private sortColumnas() {
    this.columnas.map(el => el['els'] = []);
    this.materias.map((materia, i) => {
      this.columnas[`${i % this.numColumnas}`]['els'].push(materia);
    });
  }
}
